// Stylesheet
import "../css/style.scss"
import "../css/login.scss"

// JavaScript
import PageLoader from "./modules/pageLoader.js"

import "./modules/nav.js"
import "./modules/loadMore.js"
import "./modules/anime.min.js"
import "./modules/parallax.min.js"
import "./modules/custom-ajax-script.js"
import "./modules/lazyscroll.js"
import "./modules/lazyload.js"
import "./modules/portfolio-filter.js"
import "./modules/functions.js"
import "./modules/slick-slider.js"

// Instantiate a new object using our modules/classes
var pageLoader = new PageLoader(); 
